import baseUrl from "../config/baseUrl";

// Image documents: saves the answers returned by the existing image OCR into
// ocr_data.ocr_full_data (same structure as the PDF full-document JSON) so
// the OCR "View" panel can show them. Started in the background after a
// successful Perform OCR / Re-OCR; Re-OCR overwrites the stored JSON.
const saveImageOcrFullData = async ({ token, documentId, answers }) => {
  try {
    const response = await fetch(`${baseUrl}/api/save-image-ocr-full-data`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ document_id: documentId, answers }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};

export default saveImageOcrFullData;
